var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion-plus-icon-container",style:(_vm.styles.container)},[_c('div',{staticClass:"horizontal-stick",style:(_vm.styles.hstick)}),_c('div',{staticClass:"vertical-stick",style:(_vm.styles.vstick)})])}
var staticRenderFns = []

export { render, staticRenderFns }